import { Form } from 'formik';
import { Steps } from 'primereact/steps';
import React, { useState } from 'react';
import AccountStep from './AccountStep';
import AssessmentStep from '../../Accounts/AddClientAccount/AssessmentStep';
import SurveyStep from '../../Accounts/AddClientAccount/SurveyStep';
import ReviewStep from '../../Accounts/AddClientAccount/ReviewStep';
import CreateEssentialAccountInvitationFormButtons from './CreateEssentialAccountInvitationFormButtons';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  accountDetailsStepName: { id: 'accounts.add-client.steps.account-details', defaultMessage: 'Account' },
  assessmentStepName: { id: 'accounts.add-client.steps.assessment', defaultMessage: 'Assessment' },
  surveyStepName: { id: 'accounts.add-client.steps.survey', defaultMessage: 'Survey' },
  reviewStepName: { id: 'accounts.add-client.steps.review', defaultMessage: 'Review' },
});

const CreateEssentialAccountInvitationForm = ({ createInvitationData }) => {
  const [step, setStep] = useState(0);

  const { formatMessage } = useIntl();

  const steps = [
    { label: formatMessage(messages.accountDetailsStepName) },
    { label: formatMessage(messages.assessmentStepName) },
    { label: formatMessage(messages.surveyStepName) },
    { label: formatMessage(messages.reviewStepName) },
  ];

  return (
    <Form className="p-grid">
      <div className="p-col-12">
        <Steps model={steps} activeIndex={step} onSelect={(e) => setStep(e.index)} />
      </div>
      <div className="p-sm-12 p-md-6">
        <AccountStep
          isCurrentStep={step === 0}
          account={createInvitationData.account}
          languages={createInvitationData.activeLocales}
          availableNumbersOfEmployees={createInvitationData.availableNumbersOfEmployees}
        />
      </div>
      <AssessmentStep
        isCurrentStep={step === 1}
        templates={createInvitationData.account.assessmentTemplates}
        sections={createInvitationData.account.assessmentSections}
      />
      <SurveyStep
        isCurrentStep={step === 2}
        competencies={createInvitationData.account.surveyCompetencies}
        templates={createInvitationData.account.surveyTemplates}
      />
      <ReviewStep
        isCurrentStep={step === 3}
        account={createInvitationData.account}
        sections={createInvitationData.account.assessmentSections}
      />
      <CreateEssentialAccountInvitationFormButtons step={step} setStep={setStep} />
    </Form>
  );
};

export default CreateEssentialAccountInvitationForm;
